export class PropertyPreservationDTO{
    public id?:number;
    public propertyId!:number;
    public preservationType!:string;
    public preservation!:string; //json
}